/**
 * Initializes additional Sitefinity forms functionalities.
 */
export const initSfFormAddons = () => {
	const els = [...document.querySelectorAll('[data-sf-role="form-container"]')]
		.map((el) => el.closest('form'))
		.filter((el) => !!el);

	for (const el of els) {
		scrollOnSubmit(el);
	}
};

/**
 * Scrolls to the top of the page when a Sitefinity form is submitted.
 * @param {HTMLFormElement} el - Sitefinity form element
 */
const scrollOnSubmit = (el) => {
	const scrollToTop = () => {
		scrollTo({ top: 0, behavior: 'smooth' });
	};

	el.addEventListener('submit', scrollToTop);
};
